import { render, staticRenderFns } from "./ElementSelector.vue?vue&type=template&id=2d85b4aa"
import script from "./ElementSelector.vue?vue&type=script&lang=js"
export * from "./ElementSelector.vue?vue&type=script&lang=js"
import style0 from "./ElementSelector.vue?vue&type=style&index=0&id=2d85b4aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports